import { HasVariablesInGit } from "@octopusdeploy/octopus-server-client";
import React from "react";
import type { RouteComponentProps } from "react-router-dom";
import { Switch, withRouter, Route } from "react-router-dom";
import ErrorContextProvider from "~/components/ErrorContext/ErrorContext";
import { RedirectAs404 } from "~/components/NotFound/NotFound";
import { withPage } from "~/components/Page/Page";
import pageIds from "~/pageIds";
import { BranchAwareRedirect } from "../../ProjectsRoutes/BranchAwareRedirect";
import VariablePreview from "./VariablePreview";

export const VariablePreviewPage = withPage({ page: pageIds.project().variables.all })(VariablePreview);

type VariablePreviewRouteProps = {
    path: string;
};

type Props = VariablePreviewRouteProps & RouteComponentProps<{ projectSlug: string }>;

class VariablePreviewRoute extends React.Component<Props> {
    render() {
        return (
            <BranchAwareRedirect condition={(project) => HasVariablesInGit(project.PersistenceSettings)}>
                <ErrorContextProvider>
                    <Switch>
                        <Route path={`${this.props.path}`} exact={true} render={(props) => <VariablePreviewPage {...props} />} />
                        <RedirectAs404 />
                    </Switch>
                </ErrorContextProvider>
            </BranchAwareRedirect>
        );
    }
}

const EnhancedVariablePreviewRoute = withRouter(VariablePreviewRoute);

export default EnhancedVariablePreviewRoute;
